export default "__VITE_ASSET__bcad3684__"